import { capabilities, type CapabilityKey } from "@/config/capabilities";

export type ServiceCardIconId = "terminal" | "remote" | "hub";

export type ServiceCardDef = {
  readonly iconId: ServiceCardIconId;
  readonly capability: CapabilityKey;
};

export const serviceCardDefs: readonly ServiceCardDef[] = [
  { iconId: "terminal", capability: "softwareEngineering" },
  { iconId: "remote", capability: "itSupportRmm" },
  { iconId: "hub", capability: "aiEnablement" },
] as const;

export function hrefForServiceCard(def: ServiceCardDef): string {
  return capabilities[def.capability].href;
}
